var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerBar",style:(_vm.titleBarStyle)},[_c('div',{staticClass:"bar-line"}),_c('div',{staticClass:"text-panel"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"bar-line1"})])}
var staticRenderFns = []

export { render, staticRenderFns }